import { useState } from "react";
import debounce from "lodash.debounce";
import { SearchAuctionsService } from "../services/auctions.service";
import { StatusCodes } from "http-status-codes";
import { IAuctionsData } from "../pages/account/tabComponents/auction.interface";
const SearchInput = ({ formik }: { formik: any }) => {
  const [auctions, setAuctions] = useState<IAuctionsData[]>([]);
  const debouncedSearch = debounce(async (query) => {
    const response = await SearchAuctionsService({ keyword: query } as any);
    if (response.status && response.status_code === StatusCodes.OK) {
      setAuctions(response.data.auctions);
    }
  }, 300);

  const handleInputChange = (event: any) => {
    const query = event.target.value;
    formik.setFieldValue("keyword", query);
    if (query.length > 3) debouncedSearch(query);
  };

  return (
    <div className="relative">
      <label className="block mb-2 text-sm text-gray-800">Enter Keyword</label>
      <input
        className="w-96 px-4 py-2 text-base border border-gray-300 rounded outline-none focus:ring-blue-500 focus:border-blue-500 focus:ring-1"
        type="text"
        name="keyword"
        value={formik.values.keyword}
        onChange={handleInputChange}
      />
      {auctions.length > 0 && formik.values.keyword && (
        <div className="bg-white w-auto shadow-md absolute z-10 left-0 right-0 py-3 px-3 max-h-36 overflow-auto">
          {auctions.map((x, i) => {
            return (
              <div
                onClick={() => {
                  formik.setFieldValue("keyword", x.title);
                  setAuctions([]);
                }}
                className="cursor-pointer p-2 hover:bg-gray-300 border-b-2 border-gray-300"
              >
                {x.title}
                <br />
                <span className="text-xs">{x.address}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default SearchInput;
